import React, { useState, useEffect } from "react";
import { getSiteEquipment, getBuildingEquipment, getSpaceEquipment, getZoneEquipment, updateEquipment, getSiteBuildings, getSiteSpaces, getSiteZones } from '../../services/MetadataService';
import { getBrickEquipmentTypes, getEquipmentSystems } from '../../services/DimensionsServices';
import { getProducts } from "../../services/ProductGuideService";
import EquipmentList from "../../components/EquipmentList";

const LoadedEquipmentList = (props) => {
    const [equipment, setEquipment] = useState(props.equipment)
    const [brickTypes, setBrickTypes] = useState()
    const [brickSystems, setBrickSystems] = useState()
    const [products, setProducts] = useState()

    useEffect(() => {
        if (!equipment) {
            if (props.zoneId) {
                getZoneEquipment(props.zoneId).then((response) => {
                    setEquipment(response);
                });
            } else if (props.spaceId) {
                getSpaceEquipment(props.spaceId).then(response => {
                    setEquipment(response)
                });
            } else if (props.buildingId) {
                getBuildingEquipment(props.buildingId).then(response => {
                    setEquipment(response)
                });
            } else if (props.siteId) {
                getSiteEquipment(props.siteId).then(response => {
                    setEquipment(response)
                });
            } 
    
        }

        getBrickEquipmentTypes().then(types => {
            setBrickTypes(types)
        })

        getEquipmentSystems().then(systems => {
            setBrickSystems(systems)
        })

        getProducts().then(response => {
            let products = [];
            response.forEach (r => {
                if (r.company === "Unknown" && r.model === "Unknown") return;

                products.push({
                    id: r.product_id,
                    label: r.company === "Unknown" ? r.model : r.company + " " + r.model
                })
            })
            products.sort((a, b) => (a.label > b.label) ? 1 : -1)
            setProducts(products)
        })

    },[])

    const getSiteOptions = () => {
        return {
            "id": props.siteId,
            "name": "Current Site"
        }
    }

    const submitChanges = async (equipment) => {
        console.log("Submitting update to equipment:")
        console.log(equipment)
        updateEquipment(equipment).then(response => {
            if (props.zoneId) {
                getZoneEquipment(props.zoneId).then((response) => {
                    setEquipment(response);
                });
            } else if (props.spaceId) {
                getSpaceEquipment(props.spaceId).then(response => {
                    setEquipment(response)
                });
            } else if (props.buildingId) {
                getBuildingEquipment(props.buildingId).then(response => {
                    setEquipment(response)
                });
            } else if (props.siteId) {
                getSiteEquipment(props.siteId).then(response => {
                    setEquipment(response)
                });
            } 
        })
    }

    return(
        <EquipmentList 
            equipment={equipment} 
            siteId={props.siteId} 
            buildingId={props.buildingId}
            brickTypes={brickTypes}
            brickSystems={brickSystems}
            updateEquipment={submitChanges}
            siteOptions={getSiteOptions}
            buildingOptions={getSiteBuildings}
            spaceOptions={getSiteSpaces}
            zoneOptions={getSiteZones}
            productOptions={products}
        />
    )
}

export default LoadedEquipmentList;


